
// Takes a number and returns it rounded to two decimal places. Adds two decimals if the number had fewer.
// E.g. 1 -> 1.00, 1.1 -> 1.10, 1.123 -> 1.12
export function roundToTwoDecimalPlacesAndFormat(num: number): string {
  return num.toFixed(2);
}
